"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ValidationError = require("./ValidationError");

var _ValidationError2 = _interopRequireDefault(_ValidationError);

var _RadioGroupOption = require("./RadioGroupOption");

var _RadioGroupOption2 = _interopRequireDefault(_RadioGroupOption);

var _RadioGroupLabel = require("./RadioGroupLabel");

var _RadioGroupLabel2 = _interopRequireDefault(_RadioGroupLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioGroupInline = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(RadioGroupInline, _Component);

  function RadioGroupInline() {
    (0, _classCallCheck3.default)(this, RadioGroupInline);
    return (0, _possibleConstructorReturn3.default)(this, (RadioGroupInline.__proto__ || (0, _getPrototypeOf2.default)(RadioGroupInline)).apply(this, arguments));
  }

  (0, _createClass3.default)(RadioGroupInline, [{
    key: "render",
    value: function render() {
      var fieldProps = this.props.fieldProps;

      var hasError = fieldProps.touched && fieldProps.error;
      var formGroupClasses = "form-group radio-group-inline";

      if (hasError) {
        formGroupClasses += " has-error";
      }

      return _react2.default.createElement(
        "div",
        { className: formGroupClasses },
        this.renderInlineOptions(),
        _react2.default.createElement(_ValidationError2.default, { fieldProps: this.props.fieldProps })
      );
    }
  }, {
    key: "renderInlineOptions",
    value: function renderInlineOptions() {
      var _props = this.props,
          fieldProps = _props.fieldProps,
          name = _props.name;

      return this.props.options.map(function (option, index) {
        return _react2.default.createElement(
          "div",
          { className: "radio-group-button-inline", key: option.id + "_" + index },
          _react2.default.createElement(_RadioGroupOption2.default, { name: name, option: option, fieldProps: fieldProps }),
          _react2.default.createElement(_RadioGroupLabel2.default, { option: option })
        );
      });
    }
  }]);
  return RadioGroupInline;
}(_react.Component), _class.propTypes = {
  options: _react.PropTypes.array.isRequired,
  fieldProps: _react.PropTypes.object.isRequired,
  title: _react.PropTypes.string,
  name: _react.PropTypes.string.isRequired
}, _temp);
exports.default = RadioGroupInline;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/form/RadioGroupInline.js
 ** module id = 477
 ** module chunks = 0
 **/